import { Modal, Typography } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import { useDispatch, useSelector } from 'react-redux';
import { Userpilot } from 'userpilot';
import { updateProgram } from 'state/Program/programSlice';
import { selectUserEmail, selectOrganizationId } from 'state/User/userSlice';
import { USERPILOT_EVENTS } from 'utils/constants';

type ArchiveProgramModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  programId: string;
};

const ArchiveProgramModal = ({
  isOpen,
  setIsOpen,
  programId,
}: ArchiveProgramModalProps) => {
  const dispatch = useDispatch();
  const userEmail = useSelector(selectUserEmail);
  const organizationId = useSelector(selectOrganizationId);
  const title = intl.get('PROGRAM_PAGE.ARCHIVE_PROGRAM_MODAL.TITLE');

  const handleClose = () => setIsOpen(false);

  const handleArchiveProgram = async () => {
    handleClose();
    const result = (await dispatch(
      updateProgram({
        programId,
        updateFields: { is_archived: true },
      })
    )) as any;
    if (result.payload?.updatedProgram) {
      Userpilot.track(USERPILOT_EVENTS.PROGRAM_ARCHIVED, {
        email: userEmail,
        companyId: organizationId,
        programId,
      });
    }
  };

  return (
    <Modal
      aria-label={title}
      closeModal={handleClose}
      isOpen={isOpen}
      title={title}
      size='small'
      data-testid='archive-program-modal'
      titleIcon={{
        name: 'archive',
        className: 'text-primary-dark h-5 w-5',
      }}
      actionButtons={[
        {
          children: intl.get(
            'PROGRAM_PAGE.ARCHIVE_PROGRAM_MODAL.ARCHIVE_BUTTON'
          ),
          onClick: handleArchiveProgram,
          variant: 'primary',
          'data-cy': 'modal-archive-program-button',
          className: 'h-10',
        },
        {
          children: intl.get('CANCEL'),
          onClick: handleClose,
          variant: 'tertiary',
          'data-cy': 'cancel-archive-program-button',
          className: 'h-10',
        },
      ]}
      childrenClassName='p-0'
    >
      <div className='space-y-6'>
        <Typography as='p'>
          {intl.get('PROGRAM_PAGE.ARCHIVE_PROGRAM_MODAL.BODY_1')}
        </Typography>
        <Typography as='p'>
          {intl.get('PROGRAM_PAGE.ARCHIVE_PROGRAM_MODAL.BODY_2')}
        </Typography>
      </div>
    </Modal>
  );
};

export default ArchiveProgramModal;
